<template>
  <div class="container">
    <span class="form p-fluid">
      <InputText
        class="p-mx-3 autocomplete"
        v-model="title"
        :placeholder="placeholder"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import firebase from "../firebase/firebase";
import InputText from "primevue/inputtext";

export default defineComponent({
  name: "SetTitle",
  components: { InputText },
  props:{
    placeholder:{
      type: String,
      default:"表示される楽曲のタイトル",
    }
  },
  setup() {
    return {
      title: ref(),
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
